import Services from "./services/index.js";
import TechVisits from "./tech_visits//index.js";

export default [
  ...Services,
  ...TechVisits,
]
